export default "__VITE_ASSET__B$Mumefd__"